import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Global vuex
import AppModule from './app'
import auth from './modules/auth'
import clientDashboard from './modules/clientDashboard'

import BoardModule from './modules/tickets'
import IncidenciasModule from './modules/incidencias-masivas'
import OrdenesTrabajoModule from './modules/ordenes-trabajo'
import ChatwootModule from './modules/chatwoot'
import FacturacionModule from '../apps/facturacion/store'
import CotizacionesModule from '../apps/cotizaciones/store'
import counters from './modules/counters';
import clientContext from './modules/clientContext';
import ticketsRealtime from './modules/ticketsRealtime';
import ordenesTrabajoRealtime from './modules/ordenesTrabajoRealtime';
Vue.use(Vuex)



const store = new Vuex.Store({
    modules: {
        auth,
        'client-Dashboard': clientDashboard,
        app: AppModule,
        'board-app': BoardModule,
        'incidencias': IncidenciasModule,
        'ordenes-trabajo': OrdenesTrabajoModule,
        'chatwoot': ChatwootModule,
        'facturacion-app': FacturacionModule,
        'cotizacion-app': CotizacionesModule,
        counters,
        clientContext,
        ticketsRealtime,
        ordenesTrabajoRealtime,

    },
    plugins: [
        createPersistedState({
            paths: [ 'app.themeMode', 'app.globalTheme', 'client-Dashboard.cpanel', 'auth.isAuthenticated', 'auth.isAuthenticatedFacturacion', 'auth.twoFAError', 'auth.google2fa_enable', 'cotizacion-app.step', 'cotizacion-app.data' , 'cotizacion-app.items', 'cotizacion-app.documents', 'cotizacion-app.email', 'counters.counters', 'counters.lastFetch', 'clientContext.selectedClient']
        })
    ]
})

export default store
